var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"btn btn-sm px-sm py-sm -ml-sm cursor-pointer",attrs:{"for":"checkerOfAllBoxes"}},[_c('input',{attrs:{"type":"checkbox","id":"checkerOfAllBoxes"},domProps:{"checked":_vm.anyItemsChecked},on:{"change":_vm.toggle}})])}
var staticRenderFns = []

export { render, staticRenderFns }